import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import AppAvatar, { AppAvatarProps } from '../../../Avatar/AppAvatar';
import { makeTransitionStyles } from '../../../styles';

const Image: React.FC<AppAvatarProps> = withStyles({
  root: {
    ...makeTransitionStyles('transform .5s, visibility .5s ease-in'),
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 5,
    width: '100%',
    height: '100%',
    borderRadius: 0,
  },
})(AppAvatar);

export default Image;
